<template>
  <div class="modal-vue mt-3">
    <div class="card">
      <div class="card-header bg-primary">
        <h3><i class="nav-icon fa fa-messages"></i> {{ __('message_interface.title') }}</h3>
      </div>
      <div class="card-body">
        <NavTabs :active-tab-index="step" :tabs="tabs" pills fill @selectTab="changeTab">
          <NavTabContent
            :title="getTab('step1').title"
            :active="getTab('step1').tabIndex == step"
            :disabled="getTab('step1').disabled"
          >
            <MessageType :message="message" @next-tab="step++" />
          </NavTabContent>
          <NavTabContent
            :title="getTab('step2').title"
            :active="getTab('step2').tabIndex == step"
            :disabled="getTab('step2').disabled"
          >
            <MessageModel
              @prev-tab="step--"
              :sms-templates="smsTemplates"
              :email-templates="emailTemplates"
              :message="message"
              @next-tab="step++"
              ref="message-model"
              @selectMessageModel="selectMessageModel"
            />
          </NavTabContent>
          <NavTabContent
            :title="getTab('step3').title"
            :active="getTab('step3').tabIndex == step"
            :disabled="getTab('step3').disabled"
          >
            <MessageReview
              :message="message"
              @next-tab="step++"
              @prev-tab="step--"
              ref="message-review"
              :canChangeTemplate="canChangeTemplate"
            />
          </NavTabContent>
          <NavTabContent
            :title="getTab('step4').title"
            :active="getTab('step4').tabIndex == step"
            :disabled="getTab('step4').disabled"
          >
            <MessageSelectClient
              :clients="clients"
              :message="message"
              @next-tab="step++"
              @prev-tab="step--"
              @submitSendMessage="submitSendMessage"
            />
          </NavTabContent>
          <NavTabContent
            ::title="getTab('step5').title"
            :active="getTab('step5').tabIndex == step"
            :disabled="getTab('step5').disabled"
          >
            <MessageFinish :message="message" />
          </NavTabContent>
        </NavTabs>
      </div>
    </div>
  </div>
</template>

<script>
import MessageType from './ContactCustomerSteps/MessageType.vue'
import MessageModel from './ContactCustomerSteps/MessageModel.vue'
import MessageReview from './ContactCustomerSteps/MessageReview.vue'
import MessageSelectClient from './ContactCustomerSteps/MessageSelectClient.vue'
import MessageFinish from './ContactCustomerSteps/MessageFinish.vue'
import axios from 'axios'
import NavTabs from '@components/commons/navigation/NavTabs.vue'
import NavTabContent from '@components/commons/navigation/NavTabContent.vue'
import { usePage } from '@inertiajs/vue3'

const page = usePage()

export default {
  name: 'ContactCustomer',
  props: ['smsTemplates', 'emailTemplates', 'clients', 'canChangeTemplate'],
  components: {
    MessageType,
    MessageModel,
    MessageReview,
    MessageSelectClient,
    MessageFinish,
    NavTabs,
    NavTabContent
  },
  data() {
    return {
      step: 0,
      message: {
        type: '',
        model: '',
        messageToSend: null,
        messageSubject: '',
        selectedMessageModel: {
          id: null,
          name: null,
          content: null,
          subject: null
        },
        selectedClient: null,
        options: {
          mail: {},
          sms: {}
        },
        sent: false,
        loading: false
      },
      editableVariables: [],
      editableVariablesNumber: 0,
      lang: {
        field: {
          en: 'You must customize the green fields',
          fr: 'Vous devez personnaliser les champs verts'
        },
        errors: {
          en: 'Oops, something went wrong',
          fr: 'Oups, quelque chose a mal tourné'
        }
      }
    }
  },
  computed: {
    tabs() {
      return [
        {
          title: '1. ' + this.__('message_interface.tabs.step1'),
          step: 'step1',
          disabled: this.message.sent,
          tabIndex: 0
        },
        {
          title: '2. ' + this.__('message_interface.tabs.step2'),
          step: 'step2',
          disabled: this.message.type === '' || this.message.sent,
          tabIndex: 1
        },
        {
          title: '3. ' + this.__('message_interface.tabs.step3'),
          step: 'step3',
          disabled: this.message.messageToSend == null || this.message.sent,
          tabIndex: 2
        },
        {
          title: '4. ' + this.__('message_interface.tabs.step4'),
          step: 'step4',
          disabled:
            this.message.messageToSend === null ||
            this.message.messageToSend === '' ||
            this.message.sent ||
            this.editableVariablesNumber > 0,
          tabIndex: 3
        },
        {
          title: '5. ' + this.__('message_interface.tabs.step5'),
          step: 'step5',
          disabled: !this.message.sent,
          tabIndex: 4
        }
      ]
    }
  },
  methods: {
    changeTab(tabIndex) {
      if (!this.getTabByIndex(tabIndex)?.disabled) {
        this.step = tabIndex
      }
    },
    getTabByIndex(tabIndex) {
      return this.tabs.find(x => x.tabIndex == tabIndex)
    },
    getTab(step) {
      return this.tabs.find(x => x.step == step)
    },
    submitSendMessage() {
      this.message.messageToSend = this.removeEditableTag(this.message.messageToSend)
      this.message.loading = true
      axios
        .post('/messages/customer_contact', this.message)
        .then(response => {
          if (response.status === 200) {
            this.message.sent = true
            this.message.loading = false
            this.step = this.getTab('step5')?.tabIndex
          }
        })
        .catch(error => {
          this.message.loading = false
          let message = page.props.locale === 'en' ? this.lang.errors.en : this.lang.errors.fr
          if (error.status === 400 && error.response.data?.message?.length > 0) {
            message = error.response.data.message
          }
          this.$toast.open({
            message: message,
            type: 'error',
            duration: 5000,
            dismissible: true
          })
          console.log(error)
        })
    },
    selectMessageModel(message) {
      this.message.messageToSend = message.content
      this.selectedMessage = true
      this.editableVariablesNumber = 0
      if (this.message.type === 'email' && this.message.model === 'model') {
        this.message.messageToSend = this.extractAndReplaceEditableVariables(
          this.message.messageToSend
        )
        this.message.messageToSend = this.extractAndReplaceNonEditableVariables(
          this.message.messageToSend
        )
      }
    },
    extractAndReplaceEditableVariables(message) {
      this.editableVariables = message.match(/{{(.*?)}}/g)
      message = message.replaceAll(/{{(.*?)}}/g, function (editableVariable) {
        editableVariable = editableVariable
          .replace(/[\{{\}}']/g, '')
          .replaceAll('_', ' ')
          .toLowerCase()
        return (
          "<mark contenteditable='true' class='editable-variable' style='background: #04a90961;display: initial;border: 1px solid #00e01cd4;outline: none;' >" +
          editableVariable +
          '</mark>'
        )
      })
      this.editableVariables.forEach(value => {
        message.includes(
          value
            .replace(/[\{{\}}']/g, '')
            .replaceAll('_', ' ')
            .toLowerCase()
        )
          ? this.editableVariablesNumber++
          : ''
      })
      return message
    },
    extractAndReplaceNonEditableVariables(message) {
      return message.replaceAll(/{(.*?)}/g, function (nonEditableVariable) {
        nonEditableVariable = nonEditableVariable
          .replace(/[\{\}']/g, '')
          .replaceAll('_', ' ')
          .replaceAll('-', '')
          .toLowerCase()
        return (
          "<mark  class='no-editable-variable' style='background: rgb(216 22 68 / 61%);display: initial;border: 1px solid rgba(224,0,19,0.47);outline: none;' >" +
          nonEditableVariable +
          '</mark>'
        )
      })
    },
    removeEditableTag(message) {
      let getNonEditableVariableRegex =
        /<mark \.*?class="(?:\bno-editable-variable\b.*?|.*?)".*?>(.+?)<\/mark>/gm
      message = message.replace(getNonEditableVariableRegex, function (match) {
        return (
          '{' +
          match
            .replace(/(<([^>]+)>)/gi, '')
            .replaceAll(' ', '_')
            .toUpperCase() +
          '}'
        )
      })
      message = message.replaceAll(/<mark\b[^>]*>/gi, '')
      return message
    }
  },
  watch: {
    step: {
      handler: function () {
        if (this.step === 3) {
          if (this.message.type === 'email' && this.message.model === 'model') {
            let frame = document.getElementById('content')
            let frameDoc = frame.contentDocument || frame.contentWindow.document
            this.message.messageToSend = frameDoc.documentElement.innerHTML
            this.editableVariables.forEach(value => {
              !this.message.messageToSend.includes(
                value
                  .replace(/[\{{\}}']/g, '')
                  .replaceAll('_', ' ')
                  .toLowerCase()
              )
                ? this.editableVariablesNumber--
                : ''
            })
            if (this.editableVariablesNumber > 0) {
              this.$toast.open({
                message: page.props.locale === 'en' ? this.lang.field.en : this.lang.field.fr,
                type: 'info',
                duration: 5000,
                dismissible: true
              })
              this.step = 2
            } else {
              this.step++
            }
          } else {
            this.editableVariablesNumber = 0
          }
        }
      },
      deep: true
    },
    message: {
      handler: function () {
        if (this.message.type !== 'email' || this.message.model !== 'model') {
          this.editableVariablesNumber = 0
        }
      },
      deep: true
    }
  }
}
</script>
